import {
  Checkbox,
  Col,
  Row,
  Input,
  Form,
  DatePicker,
  Button,
  message,
  Radio,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";

const Index = () => {
  const [form] = Form.useForm();

  const [contract, setContract] = useState(false);
  const [purchase, setPurchase] = useState(false);
  const [documentt, setDocumentt] = useState(false);
  const [inspection, setInspection] = useState(false);
  const [commitment, setCommitment] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const [agreement, setAgreement] = useState(false);
  const [extension, setExtension] = useState(false);

  const Changes = (e) => {
    if (e.target.value == "accept_offer") {
      setContract(true);
    } else {
      setContract(false);
    }

    if (e.target.value == "purchase&sale") {
      setPurchase(true);
    } else {
      setPurchase(false);
    }

    if (e.target.value == "fill_document") {
      setDocumentt(true);
    } else {
      setDocumentt(false);
    }

    // Optional: Handle 'extension' logic if it's based on these values
    setExtension(false); // You can adjust this as needed based on your logic
  };

  const inspectionChangees = (e) => {
    if (e.target.value == "complete_inspection") {
      setInspection(true);
      setAgreement(false);
      setCommitment(false);
      setTransfer(false);
      setExtension(false);
    } else if (e.target.value == "purchase_&_agreement") {
      setAgreement(true);
      setCommitment(false);
      setTransfer(false);
      setExtension(false);
      setInspection(false);
    } else if (e.target.value == "obtain_a_commitment") {
      setCommitment(true);
      setTransfer(false);
      setExtension(false);
      setInspection(false);
      setAgreement(false);
    } else if (e.target.value == "transfer_title") {
      setTransfer(true);
      setExtension(false);
      setInspection(false);
      setAgreement(false);
      setCommitment(false);
    } else if (e.target.value == "describe_purpose") {
      setExtension(true);
      setInspection(false);
      setAgreement(false);
      setCommitment(false);
      setTransfer(false);
    }
  };

  const subData = async (values) => {
    console.log(values);
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/extension-of-time`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Extention of Time"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  };
  return (
    <div className="main">
      <Form form={form} onFinish={subData}>
        <label>Extension of time</label>
        <Form.Item
          name="extension_of_time"
          rules={[{ required: true, message: "required" }]}
        >
          <Radio.Group
            onChange={Changes}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Radio value="accept_offer">
              1) Accept offer or contract purchase
            </Radio>

            {contract && (
              <Form.Item
                name="accept_offer_or_contract"
                rules={[{ required: true, message: "required" }]}
              >
                <DatePicker />
              </Form.Item>
            )}

            <Radio value="purchase&sale">2) Purchase & Sales</Radio>

            {purchase && (
              <Form.Item
                name="purchasesale_agreement"
                rules={[{ required: true, message: "required" }]}
              >
                <DatePicker />
              </Form.Item>
            )}

            <Radio value="fill_document">3) Fill document</Radio>

            {documentt && (
              <Row justify="space-between" gutter={16}>
                <Col md={10}>
                  <label>Document name</label>
                  <Form.Item
                    name="document_name"
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col md={10}>
                  <label>Property Address</label>
                  <Form.Item
                    name="property_address"
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            )}
          </Radio.Group>
        </Form.Item>

        <label>Reason for extension request</label>
        <Form.Item
          name="identity_document_options"
          rules={[{ required: true, message: "required" }]}
        >
          <Radio.Group
            onChange={inspectionChangees}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Radio value="complete_inspection" style={{ marginTop: "1rem" }}>
              a) Complete inspection
            </Radio>

            {inspection && (
              <>
                <Row justify={"space-between"} gutter={4}>
                  <Col md={8}>
                    <label>Property Address</label>
                    <Form.Item
                      name={"inspction_property_address"}
                      rules={[{ required: true, message: "required" }]}
                    >
                      <Input placeholder="Address" />
                    </Form.Item>
                  </Col>
                  <Col md={5}>
                    <label>New Date</label>
                    <Form.Item
                      name={"inspection_date_end"}
                      rules={[{ required: true, message: "required" }]}
                    >
                      <DatePicker />
                    </Form.Item>
                  </Col>
                  <Col md={10}></Col>
                </Row>
              </>
            )}

            <Radio value="purchase_&_agreement" style={{ marginTop: "1rem" }}>
              b) Sign a purchase & sale agreement
            </Radio>

            {agreement && (
              <>
                <Row>
                  <Col md={6}>
                    <label>New Date</label>
                    <Form.Item
                      name="purchase_agreement_start_date"
                      rules={[{ required: true, message: "required" }]}
                    >
                      <DatePicker />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            <Radio value="obtain_a_commitment" style={{ marginTop: "1rem" }}>
              c) Obtain a commitment for financing
            </Radio>

            {commitment && (
              <>
                <Row>
                  <Col md={6}>
                    <label>New Date</label>
                    <Form.Item
                      name="commitment_date"
                      rules={[{ required: true, message: "required" }]}
                    >
                      <DatePicker />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            <Radio value="transfer_title" style={{ marginTop: "1rem" }}>
              d) Transfer title to
            </Radio>

            {transfer && (
              <>
                <Row>
                  <Col md={6}>
                    <label>New Date</label>
                    <Form.Item
                      name={"transfer_title_start_date"}
                      rules={[{ required: true, message: "required" }]}
                    >
                      <DatePicker />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}

            <Radio value="describe_purpose" style={{ marginTop: "1rem" }}>
              e) Describe purpose of extension
            </Radio>

            {extension && (
              <>
                <Row justify={"space-between"} gutter={16}>
                  <Col md={12}>
                    <label>Purpose Extension</label>
                    <Form.Item
                      name={"purpose_of_extension"}
                      rules={[{ required: true, message: "required" }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col md={8}>
                    <label>New Date</label>
                    <Form.Item
                      name={"purpose_of_extension_date_end"}
                      rules={[{ required: true, message: "required" }]}
                    >
                      <DatePicker />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </Radio.Group>
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" type="primary">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
